/**
 * 指定したフィールドを新しいサイドバーウィジェットにまとめて配置するか、既存のウィジェットに挿入します。
 *
 * @param {Object} options オプションのオブジェクト
 * @param {Boolean} options.makeWidget 新しいウィジェットを作成する場合はtrueをセットします。
 * @param {String} options.widgetBasename ウィジェットのベースネームを文字列で指定します。
 * @param {String} options.widgetLabel ウィジェットの名前を文字列/HTMLで指定します。
 * @param {String} options.widgetContentTop 上部に挿入されるウィジェットのコンテンツを文字列/HTMLで指定します。
 * @param {String} options.widgetContentBottom 下部に挿入されるウィジェットのコンテンツを文字列/HTMLで指定します。
 * @param {String} options.basename 移動するフィールドのベースネームをカンマ区切りのテキストで指定します。
 * @param {String} options.selector 移動するフィールドのIDをカンマ区切りのテキストで指定します。
 * @param {String} options.pointerSelector 移動するフィールドの移動先のセレクターを指定します。
 * @param {String} options.method メソッド名を指定します。'after'、'before'、'append'、'prepend'のいずれか。
 * @returns {*}
 */
import { errorMessage } from './errorMessage.js';
import { temporaryId } from './temporaryId.js';
import { makeWidget } from './makeWidget.js';

export function moveToWidget(options) {
    const defaults = {
        makeWidget: true,
        widgetBasename: '',
        widgetLabel: 'New Widget',
        widgetContentTop: '',
        widgetContentBottom: '',
        basename: '',
        selector: '',
        pointerSelector: '',
        method: 'after'
    };

    const op = { ...defaults, ...options };

    if (!op.pointerSelector) {
        return errorMessage('MTAppMoveToWidget', 'pointerSelector is required', 'alert', false);
    }

    let selectors = op.selector.split(',');
    if (op.basename) {
        selectors = selectors.concat(op.basename.split(',').map((b) => `#${b.replace(/^c:/, 'customfield_')}-field`));
    }

    const widgetInnerId = temporaryId();
    let insertHtml = '';

    if (op.makeWidget) {
        insertHtml = makeWidget({
            basename: op.widgetBasename,
            label: op.widgetLabel,
            content: `${op.widgetContentTop}<div id="${widgetInnerId}"></div>${op.widgetContentBottom}`
        });
    } else {
        insertHtml = `<div id="${widgetInnerId}"></div>`;
    }

    const pointerElem = document.querySelector(op.pointerSelector);
    if (!pointerElem) return;

    const divElem = document.createElement('div');
    divElem.innerHTML = insertHtml;

    switch (op.method) {
        case 'before':
            pointerElem.parentNode.insertBefore(divElem, pointerElem);
            break;
        case 'append':
            pointerElem.appendChild(divElem);
            break;
        case 'prepend':
            pointerElem.insertBefore(divElem, pointerElem.firstChild);
            break;
        default:
            if (pointerElem.nextSibling) {
                pointerElem.parentNode.insertBefore(divElem, pointerElem.nextSibling);
            } else {
                pointerElem.parentNode.appendChild(divElem);
            }
    }

    selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((elem) => {
            elem.classList.remove('hidden', 'sort-enabled', 'd-none');
            elem.style.display = 'block';
            document.getElementById(widgetInnerId).appendChild(elem);
        });
    });
}
